'use strict';

/**
 * @param {Function} fn
 * @param {Function} wrapper
 * @returns {Function}
 */
export default function wrap(fn, wrapper) {
    return function wrapped(...args) {
        return wrapper.call(this, fn, ...args);
    };
}
